export default __webpack_public_path__ + "static/media/solucion-problemas.8645911d.png";